// GPC / DNT browser signals suppress non-essential tracking without requiring the consent banner.
export const hasPrivacySignal = (): boolean =>
  navigator.globalPrivacyControl === true || navigator.doNotTrack === "1";
